const NOTIFICATION_ADD = 'NOTIFICATION_ADD'
const NOTIFICATION_CLEAR_ALL = 'NOTIFICATION_CLEAR_ALL'
const NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE'
const NOTIFICATION_UPDATE = 'NOTIFICATION_UPDATE'

export {
  NOTIFICATION_ADD,
  NOTIFICATION_CLEAR_ALL,
  NOTIFICATION_REMOVE,
  NOTIFICATION_UPDATE
}
